import {
  ClientEntity,
  OperationalEntityInput
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {toCacmSource} from "./toCacmSource";
import {toOems} from "./toOems";
import {toOrganizationInformation} from "./toOrganizationInformation";

export const toOperationalEntityInput = (
  source: ClientEntity,
  transactionId?: string
): OperationalEntityInput => {
  return {
    transactionId,
    sources: [toCacmSource(source.caId)],
    organizationInformation: toOrganizationInformation(source),
    oems: source.clientNameplates ? toOems(source.clientNameplates) : []
  };
};
